module.exports = __webpack_public_path__ + "static/media/project4.ae7c8ad9.png";